import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import moment from 'moment';
import apiConfig from 'src/api/APIConfig';
import baseURL from 'src/api/BaseUrl';
import { AppState } from 'src/store';

export const baseQuery = fetchBaseQuery({
  baseUrl: baseURL,
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as AppState).user?.user?.token;
    const sponsor = ((getState() as AppState)?.user?.user as any)?.sponsor_sponsor_name;
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }
    if (sponsor) {
      headers.set('sponsor', sponsor);
    }
    headers.set('sponsor_token', `${(getState() as AppState).user?.user?.sponsorToken}`);
    headers.set('user_date_time', moment().format());
    return headers;
  }
});

export const baseQueryCTMS = fetchBaseQuery({
  baseUrl: apiConfig.appConfig.apictms,
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as AppState).user?.user?.sponsorToken;
    const sponsor = ((getState() as AppState)?.user?.user as any)?.sponsor_sponsor_name;
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }
    if (sponsor) {
      headers.set('sponsor', sponsor);
    }
    headers.set('site_token', `${(getState() as AppState).user?.user?.siteToken}`);
    headers.set('user_date_time', moment().format());
    return headers;
  }
});
